var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import React, { createContext, useContext } from "react";
export const defaultIconContextValue = {
  getIconSrc: name => void 0
};
export const iconContext = createContext(defaultIconContextValue);
export default function IconProvider(_a) {
  var _b = _a,
    {
      children,
      icons,
      getIconSrc
    } = _b,
    restProps = __objRest(_b, ["children", "icons", "getIconSrc"]);
  if (!getIconSrc && icons) {
    getIconSrc = name => icons[name];
  }
  return /* @__PURE__ */React.createElement(iconContext.Provider, {
    value: __spreadValues(__spreadProps(__spreadValues({}, defaultIconContextValue), {
      icons,
      getIconSrc
    }), restProps)
  }, children);
}
export function useIconContext() {
  return useContext(iconContext);
}